import api from './api';

export interface CreateShortLinkPayload {
  target_url: string;
  title?: string;
  source_type?: 'article' | 'event' | 'other' | string;
  source_id?: number;
  expires_at?: string | null;
  code?: string;
  active?: boolean;
}

export interface ShortLinkResponse {
  id: number;
  code: string;
  short_url: string;
  link: any;
}

export async function createShortLink(payload: CreateShortLinkPayload): Promise<ShortLinkResponse> {
  const normalized: CreateShortLinkPayload = { ...payload };
  if (normalized.target_url && !/^https?:\/\//i.test(normalized.target_url)) {
    normalized.target_url = `https://${normalized.target_url}`;
  }
  if (typeof normalized.code === 'string') {
    const s = normalized.code.trim();
    const filtered = s.replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 16);
    normalized.code = filtered || undefined;
  }
  // Prefer admin endpoint in admin contexts to avoid 400/403 on public routes
  try {
    const resAdmin = await api.post<ShortLinkResponse>('/admin/shortlinks', normalized);
    return resAdmin.data;
  } catch (_) {
    // Fallback to public/editor route if admin path is not available
    try {
      const resPublic = await api.post<ShortLinkResponse>('/shortlinks', normalized);
      return resPublic.data;
    } catch (e2: any) {
      // Last resort: public-create endpoint (strict allowed-host policy)
      const resPub = await api.post<ShortLinkResponse>('/shortlinks/public', {
        target_url: normalized.target_url!,
        title: normalized.title,
      } as any);
      return resPub.data;
    }
  }
}

// Public shortlink creation for visitors (no auth; backend validates allowed host)
export async function createPublicShortLink(payload: { target_url: string; title?: string }): Promise<ShortLinkResponse> {
  const body = { ...payload };
  if (body.target_url && !/^https?:\/\//i.test(body.target_url)) {
    body.target_url = `https://${body.target_url}`;
  }
  const res = await api.post<ShortLinkResponse>('/shortlinks/public', body);
  return res.data;
}

export async function listShortLinks(): Promise<{ items: any[] }> {
  // Prefer admin endpoint first in admin context
  try {
    const resAdmin = await api.get<{ items: any[] }>('/admin/shortlinks');
    return resAdmin.data;
  } catch (_) {
    const res = await api.get<{ items: any[] }>('/shortlinks');
    return res.data;
  }
}

export async function getShortLinkStats(id: number | string): Promise<any> {
  const res = await api.get(`/admin/shortlinks/${id}/stats`);
  return res.data;
}
